import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";

export async function getProjects(params) {
  return await new API(URL.setParams(URL.buildUrl("projects"), params)).get();
}

export async function getProject(id) {
  return await new API(URL.setId(URL.buildUrl("projects"), id)).get();
}

export async function updateBonds(id, data) {
  return await new API(URL.buildUrl(`projects/${id}/carbonCredits`)).put(data);
}

export async function updateProject(id, data) {
  return await new API(URL.buildUrl(`projects/${id}`)).put(data);
}

export async function updateCoordinates(id, data) {
  return await new API(URL.buildUrl(`projects/${id}/coordinates`)).post(data);
}

export async function patchProject(id, info) {
  const url = URL.setId(URL.buildUrl("projects"), id);
  return await new API(url).patch(info);
}

export async function postProject({
  name,
  is_private,
  country,
  co2Goal,
  ton_price,
  project_type,
  area,
  biomass,
  co2_annual_estimated,
  contract_start_date,
  contract_end_date,
  info,
  region,
  volume,
  ton_co2_issued,
  province,
}) {
  return await new API(URL.buildUrl("projects")).post({
    name,
    is_private,
    country,
    co2Goal,
    ton_price,
    project_type,
    area,
    biomass,
    co2_annual_estimated,
    contract_start_date,
    contract_end_date,
    info,
    region,
    volume,
    ton_co2_issued,
    province,
  });
}

export async function postContactProjects(id, data) {
  return await new API(URL.buildUrl(`projects/${id}/contacts`)).post(data);
}
export async function getProjectIpfs(id) {
  return await new API(URL.buildUrl(`projects/${id}/ipfs`)).get();
}
export async function removeContact(id, email) {
  return await new API(
    URL.buildUrl(`projects/${id}/contacts/${email}`)
  ).delete();
}

export async function postIpfs({
  name,
  type,
  description,
  hash,
  url,
  project,
}) {
  return await new API(URL.buildUrl("ipfs")).post({
    name,
    type,
    description,
    hash,
    url,
    project,
  });
}
export async function deleteFileIpfs(id, type) {
  return await new API(URL.buildUrl(`projects/${id}/ipfs/${type}`)).delete();
}
export async function postImpacts({ id, title, subtitle }) {
  return await new API(URL.buildUrl(`projects/${id}/impacts`)).post({
    title,
    subtitle,
  });
}

export async function postSdgs({ id, title, data }) {
  return await new API(URL.buildUrl(`projects/${id}/sdgs`)).post({
    title,
    data,
  });
}
export async function postKeys({ id, name, data, type }) {
  if (type === "key" || type === "projectDescription") {
    return await new API(URL.buildUrl("keys")).post({
      name,
      data,
      type,
    });
  }
}
export async function getProjectImages(id, params = {}) {
  let endpoint = URL.buildUrl(`projects/${id}/images`);
  const queryParams = [];
  if (params.page !== undefined) {
    queryParams.push(`page=${params.page}`);
  }
  if (params.limit !== undefined) {
    queryParams.push(`limit=${params.limit}`);
  }
  if (params.filter && Object.keys(params.filter).length > 0) {
    const filterString = JSON.stringify(params.filter);
    queryParams.push(`filter=${encodeURIComponent(filterString)}`);
  }
  if (queryParams.length > 0) {
    endpoint += `?${queryParams.join("&")}`;
  }
  return await new API(endpoint).get();
}

export async function deleteFileImage(id, id_image) {
  return await new API(
    URL.buildUrl(`projects/${id}/images/${id_image}`)
  ).delete();
}
export async function getProjectTransactions(
  id,
  state = ["accepted"],
  type = ["buy_nft", "buy_sbt"]
) {
  const stateData = JSON.stringify(state);
  const typeData = JSON.stringify(type);
  const url = URL.buildUrl(
    `projects/${id}/transactions?state=${stateData}&type=${typeData}`
  );
  return await new API(url).get();
}

export async function getImpactsByProject(id) {
  return await new API(URL.buildUrl(`projects/${id}/impacts`)).get();
}

export async function getSdgsByProject(id) {
  return await new API(URL.buildUrl(`projects/${id}/sdgs`)).get();
}

export async function deleteImpact(id, id_impact) {
  return new API(URL.buildUrl(`projects/${id}/impacts/${id_impact}`)).delete();
}

export async function deleteSdgByProject(id, id_sdg) {
  return await new API(URL.buildUrl(`projects/${id}/sdgs/${id_sdg}`)).delete();
}

export async function postSDG(projectId, { code }) {
  return await new API(URL.buildUrl(`projects/${projectId}/sdgs`)).post({
    code,
  });
}

export async function createImpact(id, data) {
  return await new API(URL.buildUrl(`projects/${id}/impacts`)).post(data);
}

export async function getProjectBlockchainTransactions(id) {
  return await new API(
    URL.buildUrl(`projects/${id}/blockchainTransactions`)
  ).get();
}
